import { render, staticRenderFns } from "./AfpeReport.vue?vue&type=template&id=5b58ffbf&scoped=true&"
import script from "./AfpeReport.vue?vue&type=script&lang=js&"
export * from "./AfpeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58ffbf",
  null
  
)

export default component.exports